module.exports = __webpack_public_path__ + "img/green-rectangle-table-4.837d22a3.png";